export const PRODUCTION_PORTAL_HOST = 'portal.flipdish.com';

/**
 * True when the hostname is exactly the production portal host, or a subdomain of it.
 * Prefer this over substring checks (e.g. `.includes`) so hosts like
 * `portal.flipdish.com.evil.com` are not treated as production.
 */
export const isProductionPortalHost = (
  hostname: string = window.location?.hostname ?? ''
): boolean =>
  hostname === PRODUCTION_PORTAL_HOST || hostname.endsWith(`.${PRODUCTION_PORTAL_HOST}`);
